import {RoutePaths} from '../../app.routes';

/**
 * UI feature toggles for company users (ROLE_COMPANY_USER).
 *
 * NOTE:
 * - Home + Settings are always visible and are intentionally NOT part of this enum.
 */
export enum CompanyUserFeature {
  REPORTS = 'REPORTS',
  SALES_INVOICES = 'SALES_INVOICES',
  PURCHASE_INVOICES = 'PURCHASE_INVOICES',
  RECEIPTS = 'RECEIPTS',
  CHATS = 'CHATS',
}

export function featureForRoute(route: string | null): CompanyUserFeature | null {
  if (!route) return null;
  switch (route) {
    case RoutePaths.Reports:
      return CompanyUserFeature.REPORTS;
    case RoutePaths.SalesInvoices:
      return CompanyUserFeature.SALES_INVOICES;
    case RoutePaths.PurchaseInvoices:
      return CompanyUserFeature.PURCHASE_INVOICES;
    case RoutePaths.Receipts:
    case RoutePaths.StatementAndMaterial:
      return CompanyUserFeature.RECEIPTS;
    case RoutePaths.Chats:
      return CompanyUserFeature.CHATS;
    default:
      return null;
  }
}
